export var AttendeeStatusEnum;
(function (AttendeeStatusEnum) {
    AttendeeStatusEnum[AttendeeStatusEnum["Assigned"] = 1] = "Assigned";
    AttendeeStatusEnum[AttendeeStatusEnum["Unassigned"] = 2] = "Unassigned";
})(AttendeeStatusEnum || (AttendeeStatusEnum = {}));
